import React from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { Container, styles } from '@mq/gatsby-components';
import { Dropdown } from '@mq/aurora-components/dist/dropdown';
import { Menu } from '@mq/aurora-components/dist/menu';
import '@mq/aurora-components/dist/style.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// import { ProductCategories } from '@mq/generated-types/dist/ProductCategories';
import {
  Product,
  Product_productCategory,
} from '@mq/generated-types/dist/Product';

const { colors } = styles.variables;
const { respondTo } = styles.mixins;

const SubNavigation = styled.header`
  background-color: ${colors.brand.secondary};
`;
const SubNavLinksContainer = styled(Container)`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-direction: row;
  min-height: 55px;
`;
interface SubNavLinkI {
  selected: boolean;
}
const SubNavLink = styled(Link)`
  display: flex;
  align-items center;
  font-size: 0.875rem;
  ${respondTo.md`
    font-size: 1rem;
  `}
  font-weight: 500;
  padding: 16px;
  color: ${colors.text.light};
  background-color: ${({ selected }: SubNavLinkI) =>
    selected ? colors.brand.tertiary : 'inherit'};
  &:hover {
    text-decoration: none;
    background-color: ${colors.brand.tertiary};
  }
  &.title {
    padding-left: 0;
  }
`;
const CategoryName = styled.div`
  display: flex;
  align-items center;
  font-size: 0.875rem;
  ${respondTo.md`
    font-size: 1rem;
  `}
  font-weight: 500;
  padding: 16px;
  color: ${colors.text.light};
  display: none;
  ${respondTo.md`
    display: inherit;
  `}
  &.title {
    padding-left: 0;
  }
`;
const MobileLink = styled(SubNavLink)`
  color: ${colors.white};
  border-top: 1px solid ${colors.brand.primary};
  width: 214px;
`;
const SubNavSection = styled.div`
  display: flex;
  align-items: stretch;
  .title {
    font-weight: 600;
    font-size: 1rem;
    letter-spacing: 0.6px;
  }
`;
const MobileSection = styled(SubNavSection)`
  display: inherit;
  ${respondTo.lg`
    display: none;
  `}
`;
const DesktopSection = styled(SubNavSection)`
  display: none;
  ${respondTo.lg`
    display: inherit;
  `}
`;
const DropdownButton = styled.a`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.border.componentDark};
  color: ${colors.white};
  padding: 0px 16px;
  height: 40px;
  span {
    text-transform: capitalize;
  }
  &:focus,
  &:hover {
    text-decoration: none;
  }
  min-width: 214px;
`;

interface SubNavI {
  products: (Product | null)[] | null;
  selectedProductId: string;
  categoryImgSrc?: string;
  title?: string;
  categorySlug?: string;
}

const SubNav: React.FC<SubNavI> = ({
  categorySlug,
  products,
  selectedProductId,
  title,
}: SubNavI) => {
  const selectedProduct = products?.filter(
    (product) => product.id === selectedProductId,
  );
  const menu = (
    <Menu
      style={{
        backgroundColor: colors.border.componentDark,
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'GoldmanSans',
        padding: '0 0 2px',
        color: colors.white,
        width: '214px',
      }}
    >
      {selectedProductId !== '~' && (
        <MobileLink to={`/products/${categorySlug}`}>Overview</MobileLink>
      )}
      {products?.map((p) => {
        if (
          p &&
          p.id &&
          p.slug &&
          p.title &&
          p.productCategory &&
          p.productCategory.length
        ) {
          const typedProductCategories =
            p.productCategory as Product_productCategory[];
          if (
            p &&
            selectedProduct &&
            selectedProduct[0] &&
            selectedProduct[0].slug === p.slug
          )
            return null;
          return (
            <MobileLink
              to={`/products/${typedProductCategories[0].slug}/${p.slug}`}
              key={p.id}
              selected={selectedProductId === p.id}
            >
              {p.title}
            </MobileLink>
          );
        }
        return null;
      })}
    </Menu>
  );

  return (
    <SubNavigation>
      <SubNavLinksContainer>
        <SubNavSection>
          {title && categorySlug && (
            <CategoryName className="title">{title}</CategoryName>
          )}
        </SubNavSection>
        <MobileSection>
          <Dropdown
            trigger={['click']}
            overlay={menu}
            style={{
              backgroundColor: colors.border.componentDark,
            }}
          >
            <DropdownButton href="#">
              <span>
                {selectedProduct[0] ? selectedProduct[0].title : 'Overview'}
              </span>
              <ExpandMoreIcon fontSize="inherit" />
            </DropdownButton>
          </Dropdown>
        </MobileSection>
        <DesktopSection>
          <SubNavLink
            to={`/products/${categorySlug}`}
            selected={selectedProductId === '~'}
          >
            Overview
          </SubNavLink>
          {products?.map((p) => {
            if (
              p &&
              p.id &&
              p.slug &&
              p.title &&
              p.productCategory &&
              p.productCategory.length
            ) {
              const typedProductCategories =
                p.productCategory as Product_productCategory[];
              return (
                <SubNavLink
                  to={`/products/${typedProductCategories[0].slug}/${p.slug}`}
                  key={p.id}
                  selected={selectedProductId === p.id}
                >
                  {p.title}
                </SubNavLink>
              );
            }
            return null;
          })}
        </DesktopSection>
      </SubNavLinksContainer>
    </SubNavigation>
  );
};

export default SubNav;
